import axios, {AxiosResponse} from 'axios'
import {ISelectPaymentOption} from '../../../coreGlobal/models/default'
import {Response} from '../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL + '/api'

const PAYMENT_OPTION_URL = `${API_URL}/payment_options/all?per_page=100`
export const getPaymentOption = (
  includeOldRecurrence?: boolean
): Promise<ISelectPaymentOption[] | undefined> => {
  const url = includeOldRecurrence
    ? `${PAYMENT_OPTION_URL}&includeOldRecurrence=1`
    : PAYMENT_OPTION_URL
  return axios
    .get(url)
    .then((response: AxiosResponse<Response<ISelectPaymentOption[]>>) => response.data)
    .then((response: Response<ISelectPaymentOption[]>) => response.data)
}
